import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ac7221dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ac7221dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7221dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac7221dc')) {
      api.createRecord('ac7221dc', component.options)
    } else {
      api.reload('ac7221dc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ac7221dc&scoped=true", function () {
      api.rerender('ac7221dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/privacy-policy/index.vue"
export default component.exports